<template>
  <div>
    <add-user-modal
      text="Add new member"
      :value="modals.addMemberModal"
      :buttonLoading="buttonLoading"
      @closeModal="resetUserAddModal"
      @callBack="memberSave"
    />
    <edit-user-modal
      text="Edit member"
      :value="modals.editMemberModal"
      :orgMemberModel="modals.clonedEditUser"
      :buttonLoading="buttonLoading"
      @closeModal="modals.editMemberModal.show = false"
      @callBack="memberUpdate"
    />
    <div class="sub-header">
      <div class="header d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <i class="mr-2 header-icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V19C4 19.55 4.45 20 5 20H19C19.55 20 20 19.55 20 19V18C20 15.34 14.67 14 12 14Z"
                fill="#353535"
              />
            </svg>
          </i>
          <h1 class="xxl">
            {{ resource["users.HeaderText"] }}
          </h1>
        </div>
        <button
          @click="addUserButtonHandler"
          class="btn sm with-icon bg-purple text-white"
        >
          <i class="icon-add" />
          {{ resource["user.AddNewMemberText"] }}
        </button>
      </div>
    </div>

    <div class="page-view">
      <div class="container p-0">
        <b-row class="p-0 m-0">
          <b-col cols="12" class="p-0">
            <div v-if="!userList.length">
              <vue-content-loading :height="150" :speed="1">
                <rect x="0" y="10" rx="4" ry="4" width="100%" height="50" />
                <rect x="0" y="70" rx="4" ry="4" width="100%" height="50" />
              </vue-content-loading>
            </div>
            <div v-else>
              <UserListHeader />
              <UserList
                :modals="modals"
                :users="userList"
                @fetchUserList="fetchUserList"
                @getUserRight="getUserRight"
              />
            </div>
          </b-col>
        </b-row>
      </div>
      <b-modal
        v-model="rightModal"
        id="modal-center"
        centered
        hide-footer
        modal-class="new-modal"
      >
        <div slot="modal-header" class="d-flex justify-content-end w-100">
          <i
            class="icon-close custom-modal-close cursor-pointer"
            @click="rightModal = false"
          />
        </div>
        <div
          class="d-flex align-items-center justify-content-center flex-column w-100"
        >
          <img src="/images/upgrade.svg" loading="lazy" alt="upgrade" />
          <h2>{{ rightPopupTitle }}</h2>
          <p>{{ rightPopupDescription }}</p>
          <div class="w-100 d-flex justify-content-between gap-3">
            <b-button
              name="cancel"
              class="border-button-user"
              @click="rightModal = false"
            >
              {{ resource["upgradePopupCancel"] }}
            </b-button>
            <b-button
              name="upgrade"
              class="bg-button gap-2 d-flex align-items-center"
              @click="
                {
                  rightModal = false;
                  routePricing();
                }
              "
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
              >
                <path
                  d="M8.49956 11.6797L11.2662 13.3531C11.7729 13.6597 12.3929 13.2064 12.2596 12.6331L11.5262 9.4864L13.9729 7.3664C14.4196 6.97973 14.1796 6.2464 13.5929 6.19973L10.3729 5.9264L9.11289 2.95307C8.88623 2.41307 8.11289 2.41307 7.88623 2.95307L6.62623 5.91973L3.40623 6.19307C2.81956 6.23973 2.57956 6.97306 3.02623 7.35973L5.47289 9.47973L4.73956 12.6264C4.60623 13.1997 5.22623 13.6531 5.73289 13.3464L8.49956 11.6797Z"
                  fill="white"
                />
              </svg>
              {{ rightPopupSubmit }}
            </b-button>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import HrVenueService from '@/services/hrvenue.service';
import { showNotification } from '@/static/helpers';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'Users',
  data() {
    return {
      modals: {
        addMemberModal: {
          show: false,
          name: '',
          surname: '',
          email: '',
        },
        editMemberModal: {
          show: false,
          name: '',
          surname: '',
          email: '',
          id: '',
          userRoleId: '',
        },
        clonedEditUser: [],
      },
      buttonLoading: false,

      rightModal: false,
      companyPackageInfo: {},
      companyTrialPackageIsExpired: null,
      addUserRight: null,
    };
  },

  components: {
    addUserModal: () => import('../common/modals/users/addUser.vue'),
    editUserModal: () => import('../common/modals/users/editUser.vue'),
    UserList: () => import('./UserList.vue'),
    UserListHeader: () => import('./UserListHeader.vue'),
  },
  async mounted() {
    this.fetchUserList();
    await this.getCompanyPackageInfo();
    await this.getCompanyTrialPackageInfo();
    await this.getUserRight();
  },

  computed: {
    ...mapState('utils', {
      userList: (state) => state.userList,
      isUserListLoading: (state) => state.isLoading,
    }),
    rightPopupTitle() {
      let message = '';
      if (this.companyPackageInfo === null) {
        if (this.companyTrialPackageIsExpired === null) {
          message = this.resource.companyTrialPackageNotStartTitle;
        } else if (this.companyTrialPackageIsExpired) {
          message = this.resource.companyTrialPackageExpiredTitle;
        } else {
          message = this.resource.companyTrialPackageExpiredNotRightTitle;
        }
      } else {
        message = this.resource.companyPackageNotRightTitle;
      }

      return message;
    },

    rightPopupDescription() {
      let message = '';
      if (this.companyPackageInfo === null) {
        if (this.companyTrialPackageIsExpired === null) {
          message = this.resource.companyTrialPackageNotStartDescription;
        } else if (this.companyTrialPackageIsExpired) {
          message = this.resource.companyTrialPackageExpiredDescription;
        } else {
          message = this.resource.companyTrialPackageExpiredNotRightDescription;
        }
      } else {
        message = this.resource.companyPackageNotRightDescription;
      }

      return message;
    },

    rightPopupSubmit() {
      if (this.companyPackageInfo === null && this.companyTrialPackageIsExpired === null) {
        return this.resource.upgradePopupStart;
      }
      return this.resource.upgradePopupSubmit;
    },
  },

  methods: {
    ...mapActions('utils', ['fetchUserList']),
    async addUserButtonHandler() {
      await this.getUserRight();

      if (this.addUserRight > 0) {
        this.modals.addMemberModal.show = true;
      } else {
        this.rightModal = true;
      }
    },
    async memberSave(member) {
      this.buttonLoading = true;
      const { created } = await HrVenueService.saveUser(member);
      if (created) {
        if (this.modals.addMemberModal.show) {
          this.modals.addMemberModal.show = false;
          this.fetchUserList({ force: true });
          this.getUserRight();
          setTimeout(() => {
            showNotification(
              this.resource['label.Success'],
              this.resource['user.UserAddedSuccessMessage'],
              'success',
            );
          }, 300);
        }
      } else {
        this.fetchUserList();
        this.getUserRight();
        this.modals.addMemberModal.show = false;
      }
      this.buttonLoading = false;
    },
    resetUserAddModal() {
      this.modals.addMemberModal.show = false;
      this.modals.addMemberModal.name = '';
      this.modals.addMemberModal.surname = '';
      this.modals.addMemberModal.email = '';
    },
    async memberUpdate(member) {
      this.buttonLoading = true;
      const { updated } = await HrVenueService.updateUser(member);
      if (updated) {
        if (this.modals.editMemberModal.show) {
          this.fetchUserList({ force: true });
          this.modals.editMemberModal.show = false;
          setTimeout(() => {
            showNotification(
              this.resource['label.Success'],
              this.resource['user.UserEditSuccessMessage'],
              'success',
            );
          }, 300);
        }
      } else {
        this.fetchUserList();
        this.modals.addMemberModal.show = false;
      }
      this.buttonLoading = false;
    },

    routePricing() {
      this.isCreated = true;
      const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;

      this.$router.push({ name: 'PricingListView', params: { lang } });
    },

    async getCompanyPackageInfo() {
      const response = await HrVenueService.getCompanyPackage();
      this.companyPackageInfo = response;
    },

    async getCompanyTrialPackageInfo() {
      const response = await HrVenueService.getCompanyTrialPackageInfo();
      this.companyTrialPackageIsExpired = response.trialPackageIsExpired;
    },

    async getUserRight() {
      const response = await HrVenueService.getUserRight();
      this.addUserRight = response.totalUsableRight;
    },
  },
};
</script>

<style lang="scss">
.new-modal {
  .modal-dialog {
    max-width: 372px;
  }
  .modal-content {
    border-radius: 12px;
  }

  .modal-header {
    border-bottom: 0;
    padding: 12px 12px 0px 12px;

    i {
      font-size: 24px;
      color: #333333;
    }
  }

  .modal-body {
    border-bottom: 0;
    padding: 0px 24px 24px 24px;

    img {
      margin-bottom: 14px;
    }

    h2 {
      color: #353535;
      text-align: center;
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: Roboto;
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: 26px;
      margin-bottom: 8px;
    }

    p {
      color: #858585;
      text-align: center;
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: Roboto;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      margin-bottom: 24px;
    }
  }

  .border-button-user {
    display: flex;
    flex: 1;
    padding: 9px 16px;
    justify-content: center;
    align-items: center;
    border-radius: 114px;
    border: 1px solid #ff8d06;
    background: transparent !important;

    color: #ff8d06;
    text-align: center;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
  }

  .bg-button {
    display: flex;
    flex: 1;
    padding: 9px 16px;
    justify-content: center;
    align-items: center;
    border-radius: 114px;
    border: 1px solid #ff8d06;
    background: #ff8d06;

    color: #fff;
    text-align: center;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
  }
}
</style>
